<template>
  <div class="Progress">
    <v-container fluid>
      <v-card>
          <v-layout align-start justify-start row fill-height pa-3>
            <h1> Ficha Personal </h1>
            <v-icon @click="reload()" large color="blue">update</v-icon>
            <v-icon @click="volver()" large color="red">undo</v-icon>

            <v-dialog
                v-model="dialog_historia_clinica"
                width="500"
              >
                <template v-slot:activator="his">
                  <v-btn
                    color="green"
                    dark
                    v-on="his.on"
                    >
                    Crear <br> Historia
                  </v-btn>
                </template>

                <v-card>
                  <v-container fluid grid-list-md>
                    <v-layout align-space-between justify-center column fill-height>
                      <v-flex xs6>
                        <v-textarea
                          rows = "2"
                          box
                          name="input-7-4"
                          label="Paciente"
                          v-model="h_clinica_paciente"
                        ></v-textarea>
                      </v-flex>
                      <v-flex xs6>
                        <v-textarea
                          rows = "2"
                          box
                          name="input-7-4"
                          label="Idx"
                          v-model="h_clinica_idx"
                        ></v-textarea>
                      </v-flex>

                      <v-flex xs6>
                        <v-textarea
                          rows = "2"
                          box
                          name="input-7-4"
                          label="Rx"
                          v-model="h_clinica_rx"
                        ></v-textarea>
                      </v-flex>
                      <v-flex xs12>
                        <v-btn color="success"  @click="EnviarEvolucion()" >Enviar</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
            </v-dialog>
            <v-spacer></v-spacer>

            <template v-if="dataEvoluciones ===null">

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span v-on="on">
                        <v-btn :disabled="dataEvoluciones ===null" color="success"  >
                          Decargar <br> Evoluciones
                          <v-icon rigth  medium color="white">
                            cloud_download
                          </v-icon>
                        </v-btn>
                      </span>
                    </template>
                    <span>No se registran evoluciones</span>
                  </v-tooltip>
                </template>
                <template v-else>
                  <download-csv
                    :data="dataEvoluciones"
                    :name="csvname + '.csv'"
                    :labels="labelsEvoluciones"
                    :fields="fieldsEvoluciones"
                  >
                    <v-btn :disabled="dataEvoluciones ===null" color="success"  >
                      Decargar <br> Evoluciones
                      <v-icon rigth  medium color="white">
                        cloud_download
                      </v-icon>
                    </v-btn>
                  </download-csv>
                </template>

            <v-dialog
              v-model="dialog_antecedentes"
              width="800"
              >
              <template v-slot:activator="ant">
                <v-btn
                  color="primary"
                  dark
                  v-on="ant.on"
                  @click="getAntecedentes"
                >
                  Antecedentes
                </v-btn>
              </template>

              <v-card color="grey lighten-3">
                <v-card-title primary-title>
                  <h1>Antecedentes</h1>
                  <v-icon large color="blue">subtitles</v-icon>
                </v-card-title>
                <v-layout align-center justify-center  column fill-height>
                  <v-container>
                    <template v-for="(item, index) in antecedentes">
                      <v-layout row wrap
                        :key="item.label"
                        align-center justify-center
                        >
                          <v-flex align-self-center xs1  py-1  >
                            <v-icon  large color="primary">trip_origin</v-icon>
                          </v-flex>

                          <v-flex align-self-center xs9 py-3 >
                            <p class="font-weight-bold text-justify">
                              {{item.label}}
                            </p>
                          </v-flex>
                          <v-flex  align-self-center xs2 py-2 >
                            <p  class="text-lg-right" >{{item.res}}</p>
                          </v-flex>
                      </v-layout>
                      <v-divider
                        v-if="index + 1 < antecedentes.length"
                        :key="index"
                      ></v-divider>
                      </template>
                  </v-container>
                </v-layout>
              </v-card>
            </v-dialog>

          </v-layout>

          <v-card-text>
          <v-layout align-start  justify-end row fill-height>

            <v-flex xs3 pr-5
              v-if="campos.probabilidad_de_tener_covid"
              >
              <v-text-field
                label="Probabilidad de tener Covid"
                placeholder=""
                v-model="probabilidad_de_tener_covid"
                box
                readonly
                color="error"
              ></v-text-field>
            </v-flex>

            <v-flex xs2 pr-3
              v-if="campos.riesgo_de_contagiarse"
              >
              <v-text-field
                label="Riesgo de contagiarse"
                placeholder=""
                v-model="riesgo_de_contagiarse"
                box
                readonly
                color="error"
              ></v-text-field>
            </v-flex>

          </v-layout>
          <v-layout align-center justify-space-around row fill-height>
              <v-flex  xs2
                v-if="campos.nombre">
                <v-text-field
                    label="Nombre"
                    placeholder=""
                    v-model="nombre"
                    box
                    readonly
                    color="blue"
                ></v-text-field>
              </v-flex>
              <v-flex  xs2
                v-if="campos.apellido"
              >
                <v-text-field
                    label="Apellido"
                    placeholder=""
                    v-model="apellido"
                    box
                    readonly
                ></v-text-field>
              </v-flex>
              <v-flex  xs2
                v-if="campos.cc"
              >
                <v-text-field
                    label="Cedula"
                    placeholder=""
                    v-model="cc"
                    box
                    readonly
                ></v-text-field>
              </v-flex>
              <v-flex  xs2
                v-if="campos.telefono_personal">
                <v-text-field
                    label="Teléfono Personal"
                    placeholder=""
                    v-model="telefono_personal"
                    box
                    readonly
                ></v-text-field>
              </v-flex>
              <v-flex  xs2
                v-if="campos.telefono_movil_supervisor">
                <v-text-field
                    label="Teléfono Móvil Supervisor"
                    placeholder=""
                    v-model="telefono_movil_supervisor"
                    box
                    readonly
                ></v-text-field>
              </v-flex>
          </v-layout>

          <v-layout  align-center justify-space-around row fill-height>
            <v-flex  xs2
              v-if="campos.tos"
              >
              <v-text-field
                label="Ha tenido Tos"
                placeholder=""
                v-model="tos"
                box
                readonly
              ></v-text-field>
            </v-flex>
            <v-flex  xs2 v-if="campos.degustar">
              <v-text-field
                dense
                label="Perdida del gusto"
                placeholder=""
                v-model="degustar"
                box
                readonly
              ></v-text-field>
            </v-flex>
            <v-flex  xs2
              v-if="campos.fatiga"
            >
              <v-text-field
                label="Fatiga"
                placeholder=""
                v-model="fatiga"
                box
                readonly
              ></v-text-field>
            </v-flex>
            <v-flex  xs2 v-if="campos.se_ha_saltado_comidas">
              <v-text-field
                label="Se ha saltado comidas"
                placeholder=""
                v-model="se_ha_saltado_comidas"
                box
                readonly
              ></v-text-field>
            </v-flex>
            <v-flex  xs2
                v-if="campos.mucosidad"
            >
              <v-text-field
                label="Mucosidad"
                placeholder=""
                v-model="mucosidad"
                box
                readonly
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-flex xs12 lg12  v-if="loadingAdv">
          <h2 class="text-md-center">No se encontraron registros de la persona</h2>
        </v-flex>

        <v-container fluid>
          <v-layout align-center justify-center row wrap >
            <v-flex v-if="tabla_temperatura" xs12 md8 lg4>

                <h3  class="text-md-center">Temperatura</h3>

                <v-card-text
                    v-if="loadingAdv"
                    class="text-xs-center"
                    >
                    <v-progress-circular
                    :size="progressSize"
                    :width="progressWidth"
                    color="info"
                    indeterminate
                    ></v-progress-circular>
                </v-card-text>

                <v-card-text v-else-if="seriesAdv===null">
                  <h4 class="text-md-center" color="error">No se encontraron datos relacionados a la cédula</h4>
                </v-card-text>

                <v-card-text v-else>
                    <chart-line
                    :chartOptions="chartOptionsAdv"
                    :chartSeries="chartSeriesAdv"
                    :key="chartAdvKey"
                    />
                </v-card-text>

            </v-flex>

            <v-flex v-if="tabla_rcardiaco" xs12 md8 lg4>

                <h3 class="text-md-center">Ritmo Cardiaco</h3>

                <v-card-text
                    v-if="loadingAdv"
                    class="text-xs-center"
                    >
                    <v-progress-circular
                    :size="progressSize"
                    :width="progressWidth"
                    color="info"
                    indeterminate
                    ></v-progress-circular>
                </v-card-text>
                <v-card-text v-else-if="seriesAdv2===null">
                  <h4 class="text-md-center" color="error">No se encontraron datos relacionados a la cedula</h4>
                </v-card-text>

                <v-card-text v-else>
                    <chart-line
                    :chartOptions="chartOptionsAdv2"
                    :chartSeries="chartSeriesAdv2"
                    :key="chartAdvKey2"
                    />
                </v-card-text>

            </v-flex>

            <v-flex  v-if="tabla_oximetria" xs12 md8 lg4>

              <h3 class="text-md-center">Oximetria</h3>

              <v-card-text
                v-if="loadingAdv"
                class="text-xs-center"
                >
                <v-progress-circular
                  :size="progressSize"
                  :width="progressWidth"
                  color="info"
                  indeterminate
                ></v-progress-circular>
              </v-card-text>

              <v-card-text v-else-if="seriesAdv3===null">
                <h4 class="text-md-center" color="error">No se encontraron datos relacionados a la cedula</h4>
              </v-card-text>

              <v-card-text v-else>

                <chart-line
                :chartOptions="chartOptionsAdv3"
                :chartSeries="chartSeriesAdv3"
                :key="chartAdvKey3"
                />
              </v-card-text>
            </v-flex>

          </v-layout>
        </v-container>
        <data-table
          :headers="headers"
          :dataVals="dataVals"
          :key="tableKey"
          modo = "'Ficha Personal'"
          :cedula="cedula"
        />
      </v-card>
    </v-container>
  </div >
</template>

<script>
import chartLine from '@/components/Charts/LineBase'
import dataTable from '@/components/Tables/TableBaseCovid'
import JsonCSV from 'vue-json-csv'

export default {

  name: 'Ficha Personal',
  components: {
    'chart-line': chartLine,
    'data-table': dataTable,
    'download-csv': JsonCSV
  },
  data () {
    return {
      cedula: null,
      backConf: {
        path: '/projects/covid/datos/',
        pathTimeLine: '/projects/covid/timeline/',
        pathOption: '/projects/covid/options/',
        pathHistorico: '/projects/covid/historico/',
        pathEvolucion: '/projects/covid/evoluciones/',
        pathAntecedentes: 'projects/covid/antecedentes/',
        page: 1
      },
      operativo: null,
      datos: null,
      search: null,

      // variables para saber por medio de peticion
      // si aplica o no reportes de cada tipo.
      oximetria: null,
      temperatura: null,
      rcardiaco: null,

      tabla_temperatura: false,
      tabla_rcardiaco: false,
      tabla_oximetria: false,

      mensaje: null,

      loadingAdv: false,
      seriesAdv: null,
      chartAdvKey: null,
      chartOptionsAdv: {
        chart: {
          zoom: {
            type: 'x',
            enabled: true
          }
        },
        colors: ['#FF1654', '#247BA0'],
        dataLabels: {
          enabled: true
        },
        legend: {
          show: true,
          position: 'bottom'
        },
        stroke: {
          curve: 'smooth'
        },

        responsive: [
          {
            breakpoint: 721,
            options: {
              legend: {
                position: 'bottom'
              }
            }
          }
        ],

        markers: {
          size: 5,

          hover: {
            sizeOffset: 6
          }
        },
        xaxis: {
          type: 'datetime',
          labels: {
            rotate: -15,
            rotateAlways: true
          },
          title: {
            text: 'Fecha'
          }
        },
        yaxis: [

          {
            axisTicks: {
              show: true
            },
            axisBorder: {
              show: true,
              colors: ['#FF1654', '#247BA0']
            },
            labels: {
              style: {
                color: '#00E396'
              }
            },
            opposite: true,
            title: {
              text: 'Avance Acumulado',
              style: {
                color: '#00E396'
              }
            },
            tooltip: {
              enabled: true
            }
          }

        ]
        // tooltip: {
        //   fixed: {
        //     enabled: true,
        //     position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
        //     offsetY: 30,
        //     offsetX: 60
        //   }
        // }
      },
      chartSeriesAdv: null,

      loadingAdv2: false,
      seriesAdv2: null,
      chartAdvKey2: null,
      chartOptionsAdv2: {
        chart: {
          zoom: {
            type: 'x',
            enabled: true
          }
        },
        colors: ['#FF1654', '#247BA0'],
        dataLabels: {
          enabled: true
        },
        legend: {
          show: true,
          position: 'bottom'
        },
        stroke: {
          curve: 'smooth'
        },

        responsive: [
          {
            breakpoint: 721,
            options: {
              legend: {
                position: 'bottom'
              }
            }
          }
        ],

        markers: {
          size: 5,

          hover: {
            sizeOffset: 6
          }
        },
        xaxis: {
          type: 'datetime',
          labels: {
            rotate: -15,
            rotateAlways: true
          },
          title: {
            text: 'Fecha'
          }
        },
        yaxis: [

          {
            axisTicks: {
              show: true
            },
            axisBorder: {
              show: true,
              colors: ['#FF1654', '#247BA0']
            },
            labels: {
              style: {
                color: '#00E396'
              }
            },
            opposite: true,
            title: {
              text: 'Avance Acumulado',
              style: {
                color: '#00E396'
              }
            },
            tooltip: {
              enabled: true
            }
          }

        ]
        // tooltip: {
        //   fixed: {
        //     enabled: true,
        //     position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
        //     offsetY: 30,
        //     offsetX: 60
        //   }
        // }
      },
      chartSeriesAdv2: null,

      loadingAdv3: false,
      seriesAdv3: null,
      chartAdvKey3: null,
      chartOptionsAdv3: {
        chart: {
          zoom: {
            type: 'x',
            enabled: true
          }
        },
        colors: ['#FF1654', '#247BA0'],
        dataLabels: {
          enabled: true
        },
        legend: {
          show: true,
          position: 'bottom'
        },
        stroke: {
          curve: 'smooth'
        },

        responsive: [
          {
            breakpoint: 721,
            options: {
              legend: {
                position: 'bottom'
              }
            }
          }
        ],

        markers: {
          size: 5,

          hover: {
            sizeOffset: 6
          }
        },
        xaxis: {
          type: 'datetime',
          labels: {
            rotate: -15,
            rotateAlways: true
          },
          title: {
            text: 'Fecha'
          }
        },
        yaxis: [

          {
            axisTicks: {
              show: true
            },
            axisBorder: {
              show: true,
              colors: ['#FF1654', '#247BA0']
            },
            labels: {
              style: {
                color: '#00E396'
              }
            },
            opposite: true,
            title: {
              text: 'Oximetria',
              style: {
                color: '#00E396'
              }
            },
            tooltip: {
              enabled: true
            }
          }

        ]
        // tooltip: {
        //   fixed: {
        //     enabled: true,
        //     position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
        //     offsetY: 30,
        //     offsetX: 60
        //   }
        // }
      },
      chartSeriesAdv3: null,

      nombre: null,
      apellido: null,
      cc: null,
      telefono_movil_supervisor: null,
      telefono_personal: null,
      tos: null,
      degustar: null,
      fatiga: null,
      se_ha_saltado_comidas: null,
      probabilidad_de_tener_covid: null,
      riesgo_de_contagiarse: null,
      mucosidad: null,

      campos: {
        nombre: false,
        apellido: false,
        cc: false,
        telefono_movil_supervisor: false,
        telefono_personal: false,
        tos: false,
        degustar: false,
        fatiga: false,
        se_ha_saltado_comidas: false,
        probabilidad_de_tener_covid: false,
        riesgo_de_contagiarse: false,
        mucosidad: false
      },

      dialog_historia_clinica: false,
      dialog_antecedentes: false,
      h_clinica_idx: null,
      h_clinica_rx: null,
      h_clinica_paciente: null,

      headers: [],
      dataVals: null,
      fields: [],
      labels: null,
      antecedentes: [],
      selected: [2],
      // Star sirve para traer de a 15 registros del historico
      star: 0,

      csvname: 'EvolucionMedica',
      dataEvoluciones: null,
      labelsEvoluciones: ['fecha', 'cuadro_clinico', 'impresion', 'recomendaciones', 'usuario'],
      fieldsEvoluciones: ['fecha', 'cuadro_clinico', 'impresion', 'recomendaciones', 'usuario']
    }
  },

  watch: {
    '$store.state.actualOperation': function () {
      this.operativo = this.$store.state.actualOperation.id
    }
  },

  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
    this.operativo = this.$store.state.actualOperation.id
    this.cedula = this.$route.params.cc
    this.getOptions()
    this.getFichaPersonal(this.cedula)
    this.getReporte()
    this.DescargarEvoluciones()
  },

  methods: {

    // Realiza peticion que devuelve los tipos de graficas
    // permitidas para el operativo
    getOptions () {
      this.tabla_temperatura = false
      this.tabla_rcardiaco = false
      this.tabla_oximetria = false

      let request = {
        method: 'get',
        url: this.backConf.pathOption,
        params: {
          operativo: this.operativo
        }
      }
      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.timelines = resp.data.timelines
          let camposAux = resp.data.campos

          if (camposAux.includes('nombre')) {
            t.campos.nombre = true
          }
          if (camposAux.includes('apellido')) {
            t.campos.apellido = true
          }
          if (camposAux.includes('cc')) {
            t.campos.cc = true
          }
          if (camposAux.includes('Teléfono Movil Supervisor')) {
            t.campos.telefono_movil_supervisor = true
          }
          if (camposAux.includes('teléfono personal')) {
            t.campos.telefono_personal = true
          }
          if (camposAux.includes('Tos')) {
            t.campos.tos = true
          }
          if (camposAux.includes('Degustar')) {
            t.campos.degustar = true
          }
          if (camposAux.includes('Fatiga')) {
            t.campos.fatiga = true
          }
          if (camposAux.includes('Se ha saltado comidas')) {
            t.campos.se_ha_saltado_comidas = true
          }
          if (camposAux.includes('Mucosidad')) {
            t.campos.mucosidad = true
          }
          if (camposAux.includes('Probabilidad de tener Covid')) {
            t.campos.probabilidad_de_tener_covid = true
          }
          if (camposAux.includes('Riesgo de Contagiarse')) {
            t.campos.riesgo_de_contagiarse = true
          }
          if (t.timelines.includes('temperatura')) {
            t.tabla_temperatura = true
            t.getTemperatura()
          }
          if (t.timelines.includes('oximetria')) {
            t.tabla_oximetria = true
            t.getOximetria()
          }
          if (t.timelines.includes('rcardiaco')) {
            t.tabla_rcardiaco = true
            t.getRCardiaco()
          }
        })
        .catch(err => console.error(err))
    },

    // Recibe Cedula y realiza peticion para obtener
    // la ficha persona de la cedula
    getFichaPersonal (cc) {
      this.loading = true
      this.datos = null
      let request = {
        method: 'get',
        url: this.backConf.path,
        params: {
          operativo: this.operativo,
          cc: this.cedula
        }
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.nombre = resp.data[0].nombre
          t.apellido = resp.data[0].apellidos
          t.cc = resp.data[0].cc
          t.telefono_movil_supervisor = resp.data[0]['Teléfono Móvil Supervisor']
          t.tos = resp.data[0].Tos
          t.degustar = resp.data[0].Degustar
          t.fatiga = resp.data[0].Fatiga
          t.se_ha_saltado_comidas = resp.data[0]['Se ha saltado comidas']
          t.telefono_personal = resp.data[0]['Teléfono Personal']
          t.mucosidad = resp.data[0]['Mucosidad']
          t.probabilidad_de_tener_covid = resp.data[0]['Probabilidad de tener Covid']
          t.riesgo_de_contagiarse = resp.data[0]['Riesgo de Contagiarse']
        })
        .catch(err => console.error(err))
    },

    // load data Temperatura
    getTemperatura () {
      this.loadingAdv = true
      let request = {
        method: 'get',
        url: this.backConf.pathTimeLine,
        params: {
          operativo: this.operativo,
          modo: 'temperatura',
          cc: this.cedula
        }
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          if (resp.data[0].data.length === 0) {
            t.mensaje = 'No hay registros relacionados a la cedula '
          } else {
            t.seriesAdv = resp.data
            t.mensaje = ''
            t.ChangeAdvance()
            t.loadingAdv = false
            t.chartAdvKey += 1
          }
        })
        .catch(function (err) {
          console.log('error en temperatura')
          t.seriesAdv = null
          t.loadingAdv = false
          console.error(err)
        })
    },

    /**
    * Cambia entre las opciones Acumulado y Diario
    */
    ChangeAdvance () {
      this.chartSeriesAdv = this.seriesAdv
      this.chartSeriesAdv[0].name = 'am'
      this.chartSeriesAdv[1].name = 'pm'

      // console.log('chartSeriesAdv')
      // console.log(this.chartSeriesAdv)

      this.chartOptionsAdv.colors = ['#FF1654', '#247BA0']
      this.chartOptionsAdv.yaxis = [
        {
          axisTicks: {
            show: true
          },
          axisBorder: {
            show: true,
            colors: ['#FF1654', '#247BA0']
          },
          labels: {
            style: {
              color: '#00E396'
            }
          },
          title: {
            text: 'Temperatura',
            style: {
              color: '#00E396'
            }
          },
          tooltip: {
            enabled: true
          }
        }
      ]

      this.advance = !this.advance
      this.chartAdvKey += 1
    },

    // load data Temperatura
    getRCardiaco () {
      this.loadingAdv2 = true
      let request = {
        method: 'get',
        url: this.backConf.pathTimeLine,
        params: {
          operativo: this.operativo,
          modo: 'rcardiaco',
          cc: this.cedula
        }
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          if (resp.data[0].data.length === 0) {
            t.mensaje = 'No hay registros relacionados a la cedula '
          } else {
            t.seriesAdv2 = resp.data
            t.mensaje = ''
            t.ChangeAdvance2()
            t.loadingAdv2 = false
            t.chartAdvKey2 += 1
          }
        })
        .catch(function (err) {
          t.seriesAdv2 = null
          // t.ChangeAdvance()
          t.loadingAdv2 = false
          console.error(err)
        })
    },

    /**
     * Cambia entre las opciones Acumulado y Diario
     */
    ChangeAdvance2 () {
      // console.log('ChangeAdvance2')
      this.chartSeriesAdv2 = this.seriesAdv2

      this.chartSeriesAdv2[0].name = 'am'

      this.chartSeriesAdv2[1].name = 'pm'
      // console.log(this.chartSeriesAdv2)
      this.chartOptionsAdv2.colors = ['#FF1654', '#247BA0']
      this.chartOptionsAdv2.yaxis = [
        {
          axisTicks: {
            show: true
          },
          axisBorder: {
            show: true,
            colors: ['#FF1654', '#247BA0']
          },
          labels: {
            style: {
              color: '#00E396'
            }
          },
          title: {
            text: 'Ritmo Cardiaco',
            style: {
              color: '#00E396'
            }
          },
          tooltip: {
            enabled: true
          }
        }
      ]

      this.advance = !this.advance
      this.chartAdvKey2 += 1
    },

    // load data Temperatura
    getOximetria () {
      this.loadingAdv3 = true
      let request = {
        method: 'get',
        url: this.backConf.pathTimeLine,
        params: {
          operativo: this.operativo,
          modo: 'oximetria',
          cc: this.cedula
        }
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          if (resp.data[0].data.length === 0) {
            // console.log('no hay nada Oximetria')
            t.mensaje = 'No hay registros relacionados a la cédula '
            // console.log("seriesAdv3:");
            // console.log(t.seriesAdv3);
          } else {
            t.seriesAdv3 = resp.data
            // console.log('SERIES:')
            // console.log(t.seriesAdv3)
            t.mensaje = ''
            t.ChangeAdvance3()
            t.loadingAdv3 = false
            t.chartAdvKey3 += 1
          }
        })
        .catch(function (err) {
          console.log('errrrrors')

          t.seriesAdv3 = null
          // t.ChangeAdvance()
          t.loadingAdv3 = false
          console.error(err)
        })
    },

    /**
     * Cambia entre las opciones Acumulado y Diario
     */
    ChangeAdvance3 () {
      // console.log('ChangeAdvance3')
      this.chartSeriesAdv3 = this.seriesAdv3
      this.chartSeriesAdv3[0].name = 'am'
      this.chartSeriesAdv3[1].name = 'pm'

      this.chartOptionsAdv3.colors = ['#FF1654', '#247BA0']
      this.chartOptionsAdv3.yaxis = [
        {
          axisTicks: {
            show: true
          },
          axisBorder: {
            show: true,
            colors: ['#FF1654', '#247BA0']
          },
          labels: {
            style: {
              color: '#00E396'
            }
          },
          title: {
            text: 'Oximetria',
            style: {
              color: '#00E396'
            }
          },
          tooltip: {
            enabled: true
          }
        }
      ]

      this.advance = this.advance
      this.chartAdvKey3 += 1
    },

    reload () {
      // this.getFichaPersonal(this.cedula)
      // console.log('datos:')
      // console.log(this.data)
      this.getOptions()
      this.getFichaPersonal(this.cedula)
      // this.getTemperatura()
      // this.getRCardiaco()
      // this.getOximetria()
    },

    volver () {
      this.$router.push({
        name: 'Reporte Covid'

      })
    },

    /**
    * Envia la evolucion del usuario con 6 parametros
    */
    EnviarEvolucion () {
      let request = {
        method: 'post',
        url: this.backConf.pathEvolucion,
        data: {
          cuadro_clinico: this.h_clinica_paciente,
          impresion: this.h_clinica_idx,
          recomendaciones: this.h_clinica_rx,
          paciente: this.cedula,
          usuario: this.$store.state.user.cedula,
          operativo: this.operativo
        }
      }

      let t = this
      this.$store.dispatch('request_back', request)

        .then(function (resp) {
          t.dialog_historia_clinica = false
          t.DescargarEvoluciones()
        })
        .catch(err => console.error(err))
    },

    /**
     * Trae registros de los sintomas de una persona
     */
    getReporte () {
      this.loading = true
      this.dataVals = null
      let request = {
        method: 'get',
        url: this.backConf.pathHistorico,
        params: {
          operativo: this.operativo,
          cedula: this.cedula,
          star: this.star
        }
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.dataVals = resp.data
          t.tableKey += 1
          t.updateTable()
          // t.chartSeries = resp.data
          // t.chartSeries.pop()
          // t.chartOptions.yaxis.pop()
          // t.loading = false
          // t.chartKey += 1
        })
        .catch(err => console.error(err))
    },

    /**
     * Trae los antecedentes de una persona, es decir
     * las respuestas del formulario inicial
     */
    getAntecedentes () {
      let request = {
        method: 'get',
        url: this.backConf.pathAntecedentes,
        params: {
          operativo: this.operativo,
          cc: this.cedula
        }
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.antecedentes = resp.data
        })
        .catch(err => console.error(err))
    },

    /**
     * Función que actualiza los datos de headers de la tabla
     */
    updateTable () {
      // let t = this
      // console.log('datavals Objects:')
      // console.log(Object.keys(t.dataVals[0]))

      let keys = Object.keys(this.dataVals[0])
      // let keys = Object.keys(this.dataVals)
      // keys.pop()

      let head = []
      let labs = []

      keys.forEach(function (k, index) {
        head.push(
          { text: k, value: k, str: ' ', width: '5%', align: '' }
        )

        labs[k] = k
      })

      // // labs.total = 'Respuestas'
      // // labs.percentage = 'Porcentaje'

      this.headers = head
      // console.log('headers::::::::')
      // console.log(this.headers)

      this.labels = labs

      this.fields = Object.keys(this.dataVals[0])
    },

    DescargarEvoluciones () {
      let request = {
        method: 'get',
        url: this.backConf.pathEvolucion,
        params: {
          op: this.operativo,
          paciente: this.cedula
        }
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          let r = resp.data.results

          if (r.length === 0) {
            t.dataEvoluciones = null
          } else {
            t.dataEvoluciones = resp.data.results
            t.csvname = t.cedula + '_EvolucionMedica'
          }
        })
        .catch(err => console.error(err))
    }

  }
}
</script>
